import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import styles from './styles.module.scss';
import Switchbox from '../../components/switchbox';
import useBoundStore from '../../store';
import Checkbox from '../../components/checkbox';
import { RadioButton } from '../../components/radio-button2';
import { BuyApartmentFlowPaths } from '../../routes';

enum SwitchView {
  Price = 'PRICE',
  Area = 'AREA',
}

enum SortField {
  Price = 'Price',
  Area = 'Area',
}

enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

const BuyApartmentSort: React.FC = () => {
  const navigate = useNavigate();
  const [prevFieldGlobalState, setPrevFieldGlobalState] = useState<string | undefined>(undefined);
  const [prevDirectionGlobalState, setPrevDirectionGlobalState] = useState<string | undefined>(
    undefined,
  );

  const setFieldGlobalState = useBoundStore((s) => s.setFieldSort);
  const setDirectionGlobalState = useBoundStore((s) => s.setDirectionSort);

  const fieldGlobalState = useBoundStore((s) => s.fieldSort);
  const directionGlobalState = useBoundStore((s) => s.directionSort);

  useEffect(() => {
    setPrevFieldGlobalState(fieldGlobalState);
    setPrevDirectionGlobalState(directionGlobalState);
  }, []);

  const handleBackPage = () => {
    setFieldGlobalState(prevFieldGlobalState);
    setDirectionGlobalState(prevDirectionGlobalState);
    navigate(-1);
  };

  const buttons: ButtonProps[] = [
    {
      label: 'Выбрать',
      variant: 'default',
      onClick: () => {
        navigate(BuyApartmentFlowPaths.aparmentDeals);
      },
    },
    {
      label: 'Отмена',
      variant: 'gray',
      onClick: handleBackPage,
    },
  ];

  const getSwitchboxProps = (label: string) => ({
    label,
    className: clsx(styles.onlyAvailable),
  });

  return (
    <BaseScreen
      padContent
      title='Сортировка'
      buttons={buttons}
      footerClassName={styles.footer}
      floatingButtons={false}
      onBackButtonClick={handleBackPage}
    >
      <div className={styles.container}>
        <div className={styles.wrapperCheckBox}>
          <RadioButton
            label={'Стоимость ↑↓'}
            className={clsx(styles.checkbox)}
            checked={fieldGlobalState === SortField.Price}
            onChange={() => {
              setFieldGlobalState(SortField.Price);
              setDirectionGlobalState(undefined);
            }}
          />
          <RadioButton
            label={'Площадь ↑↓'}
            className={clsx(styles.checkbox)}
            checked={fieldGlobalState === SortField.Area}
            onChange={() => {
              setFieldGlobalState(SortField.Area);
              setDirectionGlobalState(undefined);
            }}
          />
        </div>

        {fieldGlobalState === SortField.Price ? (
          <>
            <Switchbox
              {...getSwitchboxProps('Стоимость ↑')}
              labelPosition='left'
              checked={directionGlobalState === SortDirection.Asc}
              onChange={() => {
                setDirectionGlobalState(
                  directionGlobalState !== SortDirection.Asc ? SortDirection.Asc : undefined,
                );
              }}
            />
            <Switchbox
              {...getSwitchboxProps('Стоимость ↓')}
              labelPosition='left'
              checked={directionGlobalState === SortDirection.Desc}
              onChange={() => {
                setDirectionGlobalState(
                  directionGlobalState !== SortDirection.Desc ? SortDirection.Desc : undefined,
                );
              }}
            />
          </>
        ) : (
          <>
          <div className={styles.switchBox}>
            <Switchbox
              {...getSwitchboxProps('Площадь ↑')}
              labelPosition='left'
              checked={directionGlobalState === SortDirection.Asc}
              onChange={() => {
                setDirectionGlobalState(
                  directionGlobalState !== SortDirection.Asc ? SortDirection.Asc : undefined,
                );
              }}
            />
          </div>
            <Switchbox
              {...getSwitchboxProps('Площадь ↓')}
              labelPosition='left'
              checked={directionGlobalState === SortDirection.Desc}
              onChange={() => {
                setDirectionGlobalState(
                  directionGlobalState !== SortDirection.Desc ? SortDirection.Desc : undefined,
                );
              }}
            />
          </>
        )}
      </div>
    </BaseScreen>
  );
};

export default BuyApartmentSort;
